export default __webpack_public_path__ + "static/media/usama.ae2bb390.jpeg";